export default __webpack_public_path__ + "images/5f93a0ef91c4c12c31ca1af077555845-Daybreaker_tablet_1067x470.jpg";